var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "link"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.2429 10.3565L11.3001 9.41374L12.2429 8.47094C13.5447 7.16921 13.5447 5.05865 12.2429 3.75691C10.9411 2.45516 8.83061 2.45516 7.52888 3.75691L6.58607 4.69972L5.64326 3.75691L6.58607 2.8141C8.40855 0.991654 11.3633 0.991654 13.1857 2.8141C15.0081 4.63655 15.0081 7.59134 13.1857 9.41374L12.2429 10.3565ZM10.3573 12.2422L9.41448 13.185C7.59208 15.0075 4.63728 15.0075 2.81483 13.185C0.992386 11.3625 0.992386 8.40781 2.81483 6.58533L3.75764 5.64253L4.70045 6.58533L3.75764 7.52814C2.45589 8.82987 2.45589 10.9405 3.75764 12.2422C5.05939 13.5439 7.16995 13.5439 8.47168 12.2422L9.41448 11.2994L10.3573 12.2422ZM9.88588 5.17112L10.8287 6.11393L6.11466 10.828L5.17185 9.88514L9.88588 5.17112Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.bbc9c2236f708f845e8af6293e7a9cd6.svg";
export { ForwardRef as ReactComponent };